import { type useProfileMagicMutationsAddUIFlagMutation } from '#app/__generated__/relay/useProfileMagicMutationsAddUIFlagMutation.graphql.js';
import { type useProfileMagicMutationsGenerateProfileSuggestionsMutation } from '#app/__generated__/relay/useProfileMagicMutationsGenerateProfileSuggestionsMutation.graphql.js';
import { useContraMutation } from '#app/hooks/useContraMutation.js';
import { graphql } from '@contra/relay';

export const useProfileMagicMutations = () => {
  const [startGeneratingProfileSuggestions] =
    useContraMutation<useProfileMagicMutationsGenerateProfileSuggestionsMutation>(
      graphql`
        mutation useProfileMagicMutationsGenerateProfileSuggestionsMutation(
          $input: GenerateContraMagicProfileSuggestionsInput!
        ) {
          generateContraMagicProfileSuggestions(input: $input) {
            bioRequestId
            errors {
              __typename
              message
            }
            oneLinerRequestId
            projectRequestId
            serviceRequestId
          }
        }
      `,
    );

  const [addUIFlag] =
    useContraMutation<useProfileMagicMutationsAddUIFlagMutation>(graphql`
      mutation useProfileMagicMutationsAddUIFlagMutation(
        $input: AddUserInterfaceFlagInput!
      ) {
        addUserInterfaceFlag(input: $input) {
          errors {
            __typename
            message
          }
          userAccount {
            userInterfaceFlags
          }
        }
      }
    `);

  return {
    addUIFlag,
    startGeneratingProfileSuggestions,
  };
};
